"use client";

import { usePostHog } from "posthog-js/react";
import { useEffect, useRef } from "react";

/** Sole switch for this link: ENABLED = renders, absent/DISABLED = today's toast. */
export const POSTAPPLY_PRO_LINK_FLAG = "postapply-pro-link";

/**
 * One-line Pro entry inside the "tracked" post-apply toast (225 apply clicks/7d,
 * 0 checkouts). Reads the flag from the PostHog instance at mount; the toast only
 * reaches this state after user interaction, so flags are loaded. Off/absent
 * renders nothing.
 */
export function PostApplyProLink({ locale }: { locale: "id" | "en" }) {
	const posthog = usePostHog();
	const enabled = posthog?.isFeatureEnabled?.(POSTAPPLY_PRO_LINK_FLAG) === true;
	const viewedRef = useRef(false);

	useEffect(() => {
		if (!enabled || viewedRef.current) return;
		viewedRef.current = true;
		posthog?.capture("postapply_pro_link_viewed", { locale });
	}, [enabled, posthog, locale]);

	if (!enabled) return null;

	return (
		<a
			href={`/${locale}/pricing?intent&src=post_apply`}
			data-testid="postapply-pro-link"
			onClick={() => posthog?.capture("postapply_pro_link_clicked", { locale })}
			className="text-sm text-muted-foreground underline-offset-4 hover:underline focus-visible:ring-2 focus-visible:ring-ring"
		>
			{locale === "id"
				? "Lamar lebih cepat dengan surat lamaran AI: lihat Pro"
				: "Apply faster with AI cover letters: see Pro"}
		</a>
	);
}
